// extracted by mini-css-extract-plugin
export default {"backdrop":"ImageModal_backdrop__aCfab","image-wrapper":"ImageModal_image-wrapper__K2aJe","image":"ImageModal_image__zqWn2"};